import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import Modal from '@components/modal/Modal';
import React, { Dispatch, SetStateAction } from 'react';

import useEditChallengeLead from './_hooks/useEditChallengeLead';
import { Challenge } from 'src/types/shared/Challenge';
import DataCheck from 'lib/src/components/common/DataCheck';
import Select from '@components/form/Select';

const EditChallengeLeadModal: React.FC<EditChallengeLeadProps> = ({
    challenge,
    setShowEditLeadModal,
}) => {
    const onSuccess = () => setShowEditLeadModal(false);

    const {
        options,

        isFetching,
        fetchError,
        isPatching,
        formState,
        handleChange,
        handleSubmit,
    } = useEditChallengeLead(challenge.id, onSuccess);

    return (
        <Modal
            title="Edit challenge lead"
            size="small"
            closeModal={() => setShowEditLeadModal(false)}
        >
            <DataCheck dataExists={true} isFetching={isFetching} error={fetchError}>
                <Form
                    onCancel={() => setShowEditLeadModal(false)}
                    onSubmit={handleSubmit}
                    isPosting={isPatching}
                >
                    <FormRow>
                        <Select
                            name="leadID"
                            value={formState.leadID}
                            onChange={handleChange}
                            label="Select challenge lead"
                            options={options}
                            required
                            search
                        />
                    </FormRow>
                </Form>
            </DataCheck>
        </Modal>
    );
};

interface EditChallengeLeadProps {
    challenge: Challenge;
    setShowEditLeadModal: Dispatch<SetStateAction<boolean>>;
}

export default EditChallengeLeadModal;
